// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSpinner_root__2OyUl"};